export enum SchoolAffiliationStatus {
    WAITING_FOR_VERIFICATION = 'waiting_for_verification',
    APPROVED = 'approved',
    REJECTED = 'rejected'
}